module.exports = __webpack_public_path__ + "img/joanna_erdman_expert_exchanges_credit_likhaan_2.02ba5904.jpg";